import React from "react";

function MainFooter() {
  return (
    <footer className="main-footer">
      <p>
        Copyright &copy; 2024 Mototrad
      </p>
      {/* All rights reserved. */}
    </footer>
  );
}

export default MainFooter;